import moment from "moment";
import axios from "axios";
import config from "app/config";

export const detectedTextLang = async (text, targetLang = "en") => {
  const response = await axios.post(`${config.GOOGLE_TRANSLATE_API_URL}/detect?key=${config.GOOGLE_CLOUD_API_KEY}`, {
    q: text,
  });
  return response;
};

export const translateText = async (text, targetLang = "en") => {
  // const detectedLang = await detectedTextLang(text);
  const response = await axios.post(`${config.GOOGLE_TRANSLATE_API_URL}?key=${config.GOOGLE_CLOUD_API_KEY}`, {
    q: text,
    target: targetLang,
  });
  return response?.data?.data?.translations;
};

export const getLanguageOptions = async () => {
  const response = await fetch(`${config.GOOGLE_TRANSLATE_API_URL}/languages?key=${config.GOOGLE_CLOUD_API_KEY}&target=en`);
  const data = await response.json();

  return data?.data?.languages || [];
};

const downloadFile = ({ data, fileName, fileType }) => {
  const blob = new Blob([data], { type: fileType });

  const a = document.createElement("a");
  a.download = fileName;
  a.href = window.URL.createObjectURL(blob);
  const clickEvt = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  a.dispatchEvent(clickEvt);
  a.remove();
};

const escapeCsvCell = (value) => {
  if (value === null || value === undefined) return "";
  const str = String(value);
  // Quote if it contains comma, semicolon (Excel locales), quote, or newline
  const shouldQuote = /[",;\r\n]/.test(str);
  const escaped = str.replace(/"/g, '""');
  return shouldQuote ? `"${escaped}"` : escaped;
};

const serializeCsvValue = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return value.toString();
  }

  if (Array.isArray(value)) {
    return value.map((item) => serializeCsvValue(item)).filter(Boolean).join(" | ");
  }

  if (typeof value === "object") {
    const entries = Object.entries(value).filter(([, entryValue]) => entryValue !== null && entryValue !== undefined && entryValue !== "");
    // Avoid semicolons here because some Excel locales treat ';' as the delimiter.
    return entries.map(([key, entryValue]) => `${key}: ${serializeCsvValue(entryValue)}`).join(" | ");
  }

  return String(value);
};

export const exportToCsv = (
  headers = [],
  keys = [],
  data = [],
  fileName = "Calman",
  appendTimestamp = true,
  includeExcelSepLine = false
) => {
  // Support legacy callers that pass a single comma-separated header line,
  // while also supporting ["Col1", "Col2"] as a header array.
  const headerLines =
    headers.length > 1
      ? [headers.map((h) => escapeCsvCell(h)).join(",")]
      : headers.length === 1
        ? headers
        : [];

  const dataCsv = data.map((item) => keys.map((key) => escapeCsvCell(serializeCsvValue(item?.[key]))).join(","));
  const suffix = appendTimestamp ? "_" + moment(new Date()).format("DD_MMM_YYYY_HH_mm") : "";

  // Add UTF-8 BOM so Excel opens non-English text correctly
  const bom = "\ufeff";
  downloadFile({
    data: bom + [...headerLines, ...dataCsv].join("\n"),
    fileName: fileName + suffix + ".csv",
    fileType: "text/csv",
  });
};

export const isEmail = (value) => {
  const emailRegex = /^\S+@\S+\.\S+$/;
  return emailRegex.test(value);
};

export const isPhoneNumber = (value) => {
  const phoneNumberRegex = /^[+]?[(]?\d{1,4}[)]?[-\s./]?\d{1,3}[-\s./]?\d{1,3}[-\s./]?\d{1,4}$/;
  return phoneNumberRegex.test(value);
};

export const isYear = (value) => {
  const regex = /^[1-9]\d{3}$/; // regular expression for four-digit number starting with a non-zero digit
  return regex.test(value);
};

/** Tickets store problem categories as a list-string like "[Electrical, Hydraulics]". */
export const parseProblemCategoryList = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value !== "string") return [];
  const trimmed = value.trim();
  if (!trimmed) return [];
  const unwrapped = trimmed.startsWith("[") && trimmed.endsWith("]") ? trimmed.slice(1, -1) : trimmed;
  return unwrapped.split(", ").filter(Boolean);
};

export const formatProblemCategory = (value) => parseProblemCategoryList(value).join(", ");

export const getItNetworkCategoryLabel = (appConstants) => appConstants?.serviceProblemCategory?.IT_NETWORK || "IT (Network)";

export const hasItNetworkProblemCategory = (categories, appConstants) => {
  const label = getItNetworkCategoryLabel(appConstants);
  return (categories || []).some((item) => (typeof item === "string" ? item : item?.name) === label);
};
